import { useFlag } from '@wix/da-react-context/pkg/flags/hooks';
import { DamzContext } from '@wix/da-react-context/pkg/DamzContext';
import React, { useContext } from 'react';
import { useIsMounted } from '@wix/da-hooks/pkg/useIsMounted';
const DamzInit = ()=>{
    const { GlobalComponent } = useContext(DamzContext);
    const isDamz = useFlag('damz');
    const isMounted = useIsMounted();
    // Must have dep, feature, and not be SSR
    if (!GlobalComponent || !isDamz || !isMounted) {
        return null;
    }
    return /*#__PURE__*/ React.createElement(GlobalComponent, null);
};
DamzInit.displayName = 'DamzInit';
export default DamzInit;

//# sourceMappingURL=DamzInit.js.map